import React, { useEffect, useState } from "react";
import { euro, practiceApi } from "../../lib/practiceApi";

const CARDS = [["incarichi_acquisiti", "Incarichi con piano"], ["da_fatturare", "Rate da fatturare ora"],
  ["fatturato", "Fatturato emesso"], ["da_incassare", "Residuo da incassare"], ["incassato", "Incassato"]];

export const BillingKpi = () => {
  const [kpi, setKpi] = useState(null);
  useEffect(() => {
    const load = () => practiceApi("/finance/to-invoice?state=all").then(({ totals }) => setKpi({
      incarichi_acquisiti: totals.total_fee, da_fatturare: totals.due_now, fatturato: totals.invoiced,
      da_incassare: totals.receivable, incassato: totals.collected })).catch(() => {});
    load(); window.addEventListener("billing-updated", load); window.addEventListener("focus", load);
    return () => { window.removeEventListener("billing-updated", load); window.removeEventListener("focus", load); };
  }, []);
  if (!kpi) return null;
  return <section className="practice-workspace" data-testid="billing-kpi">
    <div className="overview-money">
      {CARDS.map(([key, label]) => <button key={key} type="button" data-testid={`billing-kpi-${key}`}>
        <span>{label}</span><strong>{euro(kpi[key])}</strong>
      </button>)}
    </div>
    {!!kpi.documenti_da_associare && <p className="muted" data-testid="billing-kpi-pending" style={{ fontSize: 11.5, marginTop: 6 }}>
      {kpi.documenti_da_associare} documenti attendono l'associazione a committente o pratica.
    </p>}
  </section>;
};
